<template>
  <div>
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addGoodsSize">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        row-key="id"
        :columns="table.columns"
        style="width: 100%"
        :scroll="{ y: 'calc(100vh - 200px)' }"
        :pagination="false"
        :loading="table.loading"
      >
        <span slot="img" slot-scope="text, record" >
           <a-avatar :size="50" shape="square"  :src="record.coverPath"/>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-button type="link" @click="deleteSize(record.id)">{{ $t('DELETE') || '删除' }}</a-button>
        </span>
      </a-table>
      <a-pagination
        class ="pagination-class"
        v-model="table.query.page"
        :total="table.query.total"
        show-size-changer
        :page-size="table.query.size"
        :pageSizeOptions="['20']"
        @showSizeChange="handleSizeChange"
        @change="handleSizeChange">
        <template
          slot="buildOptionText"
          slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
      <a-modal
        :footer="null"
        append-to-body
        :title="$t('PREVIEW')||'预览'"
        v-model="form.visible">
        <goods-size-edit
          v-if="form.visible"
          :size-id="form.data.id"
          :goods-id="this.goodsId"
          :on-cancel-handler="closeForm"
          :on-submit-handler="closeForm"
        />
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  _queryGoodsSizes,
  _deleteGoodsSize,
} from '@/api/goodsSizeApi';
import GoodsSizeEdit from '@/views/shop/goods/GoodsSizeEdit.vue';

async function getGoodsSeriesList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsSizes({
    goodsId: this.goodsId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

async function addGoodsSize() {
  this.form.data.id = null;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsSeriesList();
}

function handleSizeChange(page, size) {
  this.table.query.page = page;
  this.table.query.size = size;
  this.getGoodsSeriesList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getGoodsSeriesList();
}

async function deleteSize(goodsId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsSize(goodsId);
      this.$message.success('删除成功');
      this.getGoodsSeriesList();
    },
  });
}

const columns = [
  {
    title: '类型',
    dataIndex: 'type',
  },
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'GoodsSizeItems',
  components: {
    GoodsSizeEdit,
  },
  props: {
    goodsId: String,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns,
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 20,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getGoodsSeriesList,
    closeForm,
    handleSizeChange,
    handlePageChange,
    deleteSize,
    addGoodsSize,
  },
  created() {
    this.getGoodsSeriesList();
  },
};
</script>

<style scoped>

</style>
